import VendorStockContainer from '@components/containers/vendorStock';
import VendorLayout from '@layouts/VendorLayout';
import { type FC } from 'react';

/** The ship-it queue on its own — the Stock container pinned to its dispatch view. */
const VendorDispatch: FC = () => (
    <VendorLayout>
        <VendorStockContainer fixedView="dispatch" />
    </VendorLayout>
);

export default VendorDispatch;
